import { DragDropFile } from "../DragDropFile";
import { useEffect, useState, forwardRef, useRef, useImperativeHandle } from "react";
import { getFileUrl } from "../../services/s3";
import { UploadFilesToS3 } from "../UploadFilesToS3";
import { query, save, deleteRecord } from "../../services/object";
import {
    Box,
    Card,
    CardContent,
    CardActions,
    CardMedia,
    Divider,
    Typography,
    Button,
    IconButton,
    Breadcrumbs,
    Link,
    MenuItem,
    Menu,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { faFile } from "@fortawesome/free-solid-svg-icons";

import { iconMapping } from "./iconMapping";

import CircularProgress from "@mui/material/CircularProgress";
import "./style.css";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { format } from "date-fns";
import { styled, alpha } from "@mui/material/styles";
import RefreshIcon from "@mui/icons-material/Refresh";

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
        boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
        "& .MuiMenu-list": {
            padding: "4px 0",
        },
        "& .MuiMenuItem-root": {
            "& .MuiSvgIcon-root": {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            "&:active": {
                backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            },
        },
    },
}));

export const DocumentCard = (props) => {
    const {
        item,
        onCardClick,
        getIcon,
        getColor,
        onDownload,
        CircularProgressWithLabel,
        onDeleteClick,
        getExtension,
        readonly,
        reupload,
        disableUpload,
        height,
        title,
        maxWidth,
    } = props;

    const [actionAnchorEl, setActionAnchorEl] = useState(null);
    const actionOpen = Boolean(actionAnchorEl);

    const handleActionMenuClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionMenuClose = () => {
        setActionAnchorEl(null);
    };

    const handleActionSelect = (action) => {
        if (action === "Delete") {
            onDeleteClick(item);
        }
        setActionAnchorEl(null);
    };

    return (
        <Grid key={item.id || item.name} xs={12} md={12} lg={12} item title={title}>
            {!readonly && (
                <Card
                    sx={{
                        position: "relative",
                        cursor: "pointer",
                        height: height ? height : "120px",
                        maxWidth: maxWidth ? maxWidth : "100%",
                        p: "0px",
                    }}
                    onClick={() => onCardClick(item)}>
                    <CardContent sx={{ display: "flex", justifyContent: "center" }}>
                        {(item.status === "started" || item.status === "success") && (
                            <Box className="progress-container">
                                {" "}
                                <CircularProgressWithLabel
                                    sx={{ fontSize: "10px" }}
                                    value={item.percentage || 5}></CircularProgressWithLabel>{" "}
                            </Box>
                        )}
                        {item.status !== "started" && (
                            // <Box>

                            //     <RefreshIcon></RefreshIcon>
                            // </Box>
                            <>
                                <img
                                    style={{
                                        height: height ? height : "120px",
                                        width: "100%",
                                        objectFit: "cover",
                                        border: "1px solid #ededed",
                                        borderRadius: "5px",
                                    }}
                                    src={item.fileURL}
                                    title={title}
                                    alt={item.fileName}></img>
                                {!disableUpload && (
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            right: "10px",
                                            top: "10px",
                                            border: "2px solid #2c95f0",
                                            borderRadius: "50px",
                                            height: "28px",
                                            width: "28px",
                                            background: "white",
                                        }}>
                                        <RefreshIcon sx={{ color: "#2c95f0" }} onClick={reupload}></RefreshIcon>
                                    </Box>
                                )}
                            </>
                        )}
                    </CardContent>
                </Card>
            )}
            {readonly && (
                <Card
                    sx={{ position: "relative", cursor: "pointer", p: "5px 15px" }}
                    onClick={(event) => onDownload(event, item)}>
                    <CardMedia
                        sx={{ alignItems: "center", mr: "15px", fontSize: "1.3rem", color: getColor(item.fileName) }}>
                        <Grid
                            sx={{ width: "100%", padding: "0" }}
                            container
                            wrap="nowrap"
                            spacing={0}
                            justifyContent="space-between"
                            alignItems="center">
                            <Grid item>
                                <FontAwesomeIcon icon={getIcon(item.fileName)} />
                                <Typography
                                    sx={{ marginTop: "-8px", textTransform: "uppercase", fontSize: "10px" }}
                                    component="div"
                                    noWrap
                                    variant="caption"
                                    color="text.secondary">
                                    {getExtension(item.fileName)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardMedia>
                    <CardContent>
                        <Typography noWrap gutterBottom variant="h6" component="div">
                            {item.name}
                        </Typography>
                        <Typography sx={{ mt: "-6px" }} noWrap variant="caption" color="text.secondary" component="div">
                            {item.createdDate && format(new Date(item.createdDate), "MMM d, yyyy HH:mm a")}
                        </Typography>
                    </CardContent>
                </Card>
            )}
        </Grid>
    );
};
